var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"segmental-control"},_vm._l((_vm.buttons),function(button){return _c('div',{key:button.value,staticClass:"segmental-control__item",class:{
      active: _vm.selectedButton === button.value,
      'style-basic': _vm.itemStyle === 'style-basic',
      'style-primary': _vm.itemStyle === 'style-primary',
    },on:{"click":function($event){return _vm.selectOption(button.value)}}},[_vm._v(" "+_vm._s(button.title)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }